module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100vh",
      "overflow-y": "hidden"
    },
    style: ({
      'background': 'linear-gradient(180deg, #22C9FE 0%, #0172F2 100%)'
    })
  }, [_c('div', {
    staticClass: "machine-head",
    staticStyle: {
      "font-size": "60px",
      "letter-spacing": "10px",
      "height": "120px",
      "line-height": "120px",
      "text-shadow": "2px 2px 0 #000, -2px -2px 0 #000, 2px -2px 0 #000, -2px 2px 0 #000",
      "position": "relative"
    },
    style: ({
      'color': '#fff',
      'background': '#ea0000'
    })
  }, [_c('img', {
    staticStyle: {
      "width": "100px",
      "margin-right": "10px",
      "position": "absolute"
    },
    attrs: {
      "src": _vm.row.score_logo ? _vm.row.score_logo : 'https://wa.ccachina.net/img/logo.58b57af4.png'
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.row.title) + "\n      当前队伍\n    ")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "100px",
      "position": "absolute",
      "float": "right",
      "top": "20px",
      "right": "20px"
    },
    attrs: {
      "src": "https://wa.ccachina.net/img/logo.58b57af4.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-image": "linear-gradient(#f9f400 0%, #f9f400 48%, #f9f400 100%)",
      "height": "100px",
      "letter-spacing": "0.2em",
      "text-shadow": "2px 2px 0 white, -2px -2px 0 white, 2px -2px 0 white, -2px 2px 0 white",
      "line-height": "100px",
      "margin": "10px",
      "text-align": "center",
      "color": "#000",
      "font-size": "50px",
      "padding": "0px 20px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.start.subject_name_group))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-image": "linear-gradient(180deg, #002CDA 0%, #011C9D 48%, #002CDA 100%)",
      "height": "auto",
      "line-height": "140px",
      "margin": "10px",
      "text-align": "left",
      "color": "#ffffffcc",
      "font-size": "80px",
      "padding": "0",
      "font-weight": "bold"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "padding": "0 20px",
      "font-size": "70px",
      "background-image": "linear-gradient(180deg, #9343FE 0%, #5A1AC9 48%, #9343FE 100%)",
      "text-align": "center",
      "margin-right": "10px"
    }
  }, [_vm._v("\n    出场顺序 " + _vm._s(_vm.thisIndex + 1) + "\n  ")]), _vm._v("\n  " + _vm._s(_vm.start.subject_name_s))]), _vm._v(" "), _c('div', {
    staticClass: "machine-box",
    staticStyle: {
      "margin": "10px",
      "height": "100%",
      "background-image": "linear-gradient(180deg, #002CDA 0%, #011C9D 48%, #002CDA 100%)"
    },
    style: ({
      'color': _vm.row.show_font_color
    })
  }, [_c('div', {
    staticClass: "machine-content"
  }, [_c('div', {
    staticClass: "machine-army",
    staticStyle: {
      "text-shadow": "4px 4px 4px #000000",
      "color": "#edc37d",
      "font-family": "diyfont"
    }
  }, [_vm._v(_vm._s(_vm.start.mingcheng))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21741c32","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/score/ScoreStartArmy2.vue
// module id = 2264
// module chunks = 0